import * as DialogPrimitive from '@radix-ui/react-dialog';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';

export type ModalDescriptionProps = DialogPrimitive.DialogDescriptionProps & {
    hidden?: boolean;
};

export function ModalDescription({
    children,
    hidden,
    ...props
}: ModalDescriptionProps) {
    const element = <DialogPrimitive.DialogDescription {...props} />;

    if (!hidden) {
        return element;
    }

    return <VisuallyHidden.Root asChild>{element}</VisuallyHidden.Root>;
}
